import { Badge } from '@/components/ui/badge'
import { Plus } from 'lucide-react'

interface SuggestedTopicsProps {
  topics: string[]
}

export function SuggestedTopics({ topics }: SuggestedTopicsProps) {
  return (
    <div className="space-y-2">
      <span className="text-sm font-medium text-primary">Tópicos Sugeridos:</span>
      <div className="flex flex-wrap gap-2 items-center">
        {topics.map((topic, index) => (
          <Badge key={index} className="bg-primary text-primary-foreground border-primary">{topic}</Badge>
        ))}
        <Badge 
          className="bg-primary text-primary-foreground border-primary cursor-pointer hover:bg-primary/90 flex items-center gap-1"
          onClick={() => console.log('Adicionar tópico')}
        >
          <Plus className="w-3 h-3" />
          Adicionar
        </Badge>
      </div>
    </div>
  )
}
